import React, { useState } from 'react';
import styles from './dwn-style.module.css'; 
import {useLocation } from "react-router-dom";
import { useNavigate } from 'react-router-dom';

const Authenticate = () => {


  const location = useLocation();
  const [pid] = useState(location.state.pid)
  const [uid] = useState(location.state.uid)
  const [code, setCode] = useState("")  
  const [message, setMessage] = useState("")
  const navigate = useNavigate();




  const inputChangeCode = (value) =>{

    setMessage("")
    setCode(value)

}

const getRole = async () => {

    const connectionString = "https://app.digitalwellnessnurse.com"; //https://app.digitalwellnessnurse.com  http://localhost:2001
    
    try {
      const response = await fetch(`${connectionString}/api/portal/role`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify({ pid }),
      });
  
      if (response.status === 200) {
        const data = await response.json();
        return data.role// Return the profiles from the backend
      } else {
        console.error("Failed to retrieve profiles:", response.status);
        return [];
      }
    } catch (error) {
      console.error("Error fetching profiles:", error);
      return [];
    }
  };

  const verify = async () =>{

    const role = await getRole()


    const body = {"username":pid,"code":code}

    let connectionString = "https://app.digitalwellnessnurse.com" //https://app.digitalwellnessnurse.com  http://localhost:2001
    fetch(connectionString+'/api/portal/code', {
        method: 'POST',
        headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        },
        credentials: "include",
        body: JSON.stringify(body),
    }).then((response) => {
        if(response.status == 200)
        {
            if(role != "Administrator"){
                navigate('/Portal', { state: {pid: pid, uid:uid, role:role} });
            }
            else{
                navigate('/FitAdminDashboard', { state: {pid: pid, uid:uid, role:role} });

            }

        }
        else if(response.status == 401) {
            setMessage("Incorrect code, try again.")
        }

        else if(response.status == 452 ){
            setMessage("Code has expired, sign in again.")
        }

        else if(response.status == 500 ){
            setMessage("DWN unavailble contact jerome@mahi-labs")
        }
            
    }
    ).catch((error) => {
        console.log(error)
    })


   }


    return (
        <div className={styles.authCenter}>
             <p><span className={styles.authDirections}> A code was sent to your messages within the DWN app</span></p>
             <div className={styles.loginContainer}>
             <div className={styles.loginItems}>
                    <p><span className={styles.loginMessage}>{message}</span></p>
                     <p className={styles.logintText}>Enter Code</p>
                    <input
                        className={styles.loginInput}
                        type="password"
                        onChange={e => inputChangeCode(e.target.value)}
                    />
                    <p>
                         <div className={styles.loginBttnContainer}>
                            <button onClick={verify} type="button" className={styles.loginBttn}><span className={styles.loginBttnLabel}>Authenticate</span></button>
                         </div>
                    </p>
                        
                </div>
             </div>
        </div>
        
    );
};
 
export default Authenticate;